import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const CostCentersListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('costCenters.costCenters_title')}></Common.Header>;
};

export default translate()(CostCentersListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/CostCentersListHeader.js